import {
  EndPointsNames,
  ApiCredentialsType,
  ErrorResponseCodeType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/legalGuardian/validate';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_AUTH_USER';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/ad63a75f-dda5-49de-8257-68299ecd1880?version=5bee6c61-5ad3-449f-bb13-8649ba93748b&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    message:
      'Ocorreu um erro técnico (Erro inesperado, favor contactar a Smiles)',
    bussinessErrorVariant: 'errorService',
  },
  {
    code: '3',
    message: 'Usuário informado é MENOR de idade',
    bussinessErrorVariant: 'minor',
  },
  {
    code: '203',
    message: 'Membro com status Pre Cadastro Banco.',
    bussinessErrorVariant: 'userPreIdentificated',
  },
  {
    code: '204',
    message:
      'Não foi possível acessar a conta. Para maiores informações, entre em contato com a central de atendimento Smiles.',
    bussinessErrorVariant: 'userNotFound',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
